import { FC } from 'react';

export const Counterparty: FC = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeMiterlimit="10"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon-bank">
    <path d="M12.37 2.15L21.37 5.75C21.72 5.89 22 6.31 22 6.68V10C22 10.55 21.55 11 21 11H3C2.45 11 2 10.55 2 10V6.68C2 6.31 2.28 5.89 2.63 5.75L11.63 2.15C11.83 2.07 12.17 2.07 12.37 2.15Z" />
    <path d="M22 22H2V19C2 18.45 2.45 18 3 18H21C21.55 18 22 18.45 22 19V22Z" />
    <path d="M4 18V11" />
    <path d="M8 18V11" />
    <path d="M12 18V11" />
    <path d="M16 18V11" />
    <path d="M20 18V11" />
    <path d="M1 22H23" />
    <path d="M12 8.5C12.8284 8.5 13.5 7.8284 13.5 7C13.5 6.1716 12.8284 5.5 12 5.5C11.1716 5.5 10.5 6.1716 10.5 7C10.5 7.8284 11.1716 8.5 12 8.5Z" />
  </svg>
);

export default Counterparty;
